export const supportNeedsCatalog = ['TEA', 'TDAH', 'TOC', 'Down', 'discalculia', 'ansiedade matemática', 'outros']
export const learningInterestCatalog = ['números', 'operações', 'material dourado', 'rotinas ABA', 'programação', 'games educativos']

export const initialAnamnesisForm = {
  studentName: '', age: '', schoolYear: '', supportNeeds: [], diagnosisNotes: [], interests: [], mathChallenges: [],
  reasonForConsultation: '', currentComplaints: '', prenatalHistory: '', birthHistory: '', developmentalHistory: '', languageHistory: '',
  schoolingHistory: '', therapeuticFollowUp: '', familyRoutine: '', sensoryProfile: '', behaviorRegulation: '', socialInteraction: '', autonomyLevel: '',
  attentionProfile: '', compulsionsOrRigidity: '', abaStrategies: '', useOfManipulatives: '', goldenMaterialExperience: '', digitalAffinity: '',
  programmingInterest: '', gamesPreference: '', emotionalTriggers: '', calmingStrategies: '', goalsForMathLearning: '', goalsForProgramming: '',
  goalsForGames: '', additionalObservations: '', notes: '', appointmentDate: '', appointmentTime: '10:00:00'
}

export const anamnesisSections = [
  {
    title: 'Desenvolvimento e histórico',
    fields: [
      ['prenatalHistory', 'História gestacional/pré-natal'],
      ['birthHistory', 'Nascimento e primeiros cuidados'],
      ['developmentalHistory', 'Marcos do desenvolvimento'],
      ['languageHistory', 'Histórico de linguagem e comunicação'],
      ['schoolingHistory', 'Histórico escolar e matemática'],
      ['therapeuticFollowUp', 'Terapias, profissionais e laudos']
    ]
  },
  {
    title: 'Funcionamento atual e adaptações',
    fields: [
      ['familyRoutine', 'Rotina familiar e estudo em casa'],
      ['sensoryProfile', 'Perfil sensorial'],
      ['behaviorRegulation', 'Autorregulação e comportamento'],
      ['socialInteraction', 'Interação social'],
      ['autonomyLevel', 'Nível de autonomia'],
      ['attentionProfile', 'Atenção, hiperfoco e distrações'],
      ['compulsionsOrRigidity', 'Rigidez, rituais ou compulsões'],
      ['abaStrategies', 'Estratégias ABA que funcionam'],
      ['useOfManipulatives', 'Uso de materiais concretos'],
      ['goldenMaterialExperience', 'Experiência com material dourado'],
      ['digitalAffinity', 'Afinidade com recursos digitais'],
      ['programmingInterest', 'Interesse em programação'],
      ['gamesPreference', 'Preferências por games'],
      ['emotionalTriggers', 'Gatilhos emocionais'],
      ['calmingStrategies', 'Estratégias que acalmam'],
      ['goalsForMathLearning', 'Metas para matemática'],
      ['goalsForProgramming', 'Metas para programação'],
      ['goalsForGames', 'Metas para games'],
      ['additionalObservations', 'Observações adicionais']
    ]
  }
]

export function normalizeSupportQuestionnaire(form) {
  return {
    studentName: form.studentName || '',
    grade: form.schoolYear || form.grade || '',
    schoolYear: form.schoolYear || form.grade || '',
    mathDifficulty: Array.isArray(form.mathChallenges) ? form.mathChallenges.join(', ') : (form.mathChallenges || ''),
    concreteMaterial: form.useOfManipulatives || '',
    blocksInterest: form.programmingInterest || '',
    gamesInterest: form.gamesPreference || '',
    emotionalResponse: form.behaviorRegulation || form.emotionalTriggers || '',
    familyGoals: form.goalsForMathLearning || '',
    supportNeeds: form.supportNeeds || [],
    diagnosisNotes: form.diagnosisNotes || [],
    currentComplaints: form.currentComplaints || '',
    reasonForConsultation: form.reasonForConsultation || '',
    attentionProfile: form.attentionProfile || '',
    abaStrategies: form.abaStrategies || '',
    useOfManipulatives: form.useOfManipulatives || '',
    goldenMaterialExperience: form.goldenMaterialExperience || '',
    goalsForProgramming: form.goalsForProgramming || '',
    goalsForGames: form.goalsForGames || '',
    additionalObservations: form.additionalObservations || ''
  }
}

export function buildAppointmentPayload({ form, selectedProfessional, userName }) {
  return {
    professionalId: selectedProfessional.id,
    professionalName: selectedProfessional.name,
    appointmentDate: form.appointmentDate,
    appointmentTime: form.appointmentTime,
    durationMinutes: 90,
    serviceType: 'anamnese',
    modality: 'online',
    notes: form.notes,
    studentProfile: {
      studentName: form.studentName || userName || '',
      age: form.age,
      schoolYear: form.schoolYear,
      diagnosisNotes: form.diagnosisNotes,
      supportNeeds: form.supportNeeds,
      interests: form.interests,
      mathChallenges: form.mathChallenges
    },
    intakeForm: {
      reasonForConsultation: form.reasonForConsultation,
      currentComplaints: form.currentComplaints,
      prenatalHistory: form.prenatalHistory,
      birthHistory: form.birthHistory,
      developmentalHistory: form.developmentalHistory,
      languageHistory: form.languageHistory,
      schoolingHistory: form.schoolingHistory,
      therapeuticFollowUp: form.therapeuticFollowUp,
      familyRoutine: form.familyRoutine,
      sensoryProfile: form.sensoryProfile,
      behaviorRegulation: form.behaviorRegulation,
      socialInteraction: form.socialInteraction,
      autonomyLevel: form.autonomyLevel,
      attentionProfile: form.attentionProfile,
      compulsionsOrRigidity: form.compulsionsOrRigidity,
      abaStrategies: form.abaStrategies,
      useOfManipulatives: form.useOfManipulatives,
      goldenMaterialExperience: form.goldenMaterialExperience,
      digitalAffinity: form.digitalAffinity,
      programmingInterest: form.programmingInterest,
      gamesPreference: form.gamesPreference,
      emotionalTriggers: form.emotionalTriggers,
      calmingStrategies: form.calmingStrategies,
      goalsForMathLearning: form.goalsForMathLearning,
      goalsForProgramming: form.goalsForProgramming,
      goalsForGames: form.goalsForGames,
      additionalObservations: form.additionalObservations
    }
  }
}
